import { PayloadAction } from '@reduxjs/toolkit';

import { AppState } from 'editor/src/store/app/types';

const setShowRealisticPreviewReducer = (state: AppState, { payload }: PayloadAction<boolean>) => {
  state.showRealisticPreview = payload;
};

export default setShowRealisticPreviewReducer;
